export default {
  momentLocale: 'zh-cn',
  Timeline: {
    expand: '展开',
    fold: '收起',
  },
  Balloon: {
    close: '关闭',
    confirm: '确定',
    cancel: '取消',
  },
  Card: {
    expand: '展开',
    fold: '收起',
  },
  Calendar: {
    today: '今天',
    now: '此刻',
    ok: '确定',
    clear: '清除',
    month: '月',
    year: '年',
    prevYear: '上一年',
    nextYear: '下一年',
    prevMonth: '上个月',
    nextMonth: '下个月',
    prevDecade: '前十二年',
    nextDecade: '后十二年',
    yearSelectAriaLabel: '选择年份',
    monthSelectAriaLabel: '选择月份',
    format: {
      months: '1 月_2 月_3 月_4 月_5 月_6 月_7 月_8 月_9 月_10 月_11 月_12 月'.split('_'),
      shortMonths: '1 月_2 月_3 月_4 月_5 月_6 月_7 月_8 月_9 月_10 月_11 月_12 月'.split('_'),
      weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
      shortWeekdays: '日_一_二_三_四_五_六'.split('_'),
      veryShortWeekdays: '日_一_二_三_四_五_六'.split('_'),
      yearLabel: 'YYYY 年',
    },
  },
  DatePicker: {
    placeholder: '请选择日期',
    datetimePlaceholder: '请选择日期和时间',
    monthPlaceholder: '请选择月',
    yearPlaceholder: '请选择年',
    now: '此刻',
    selectTime: '选择时间',
    selectDate: '选择日期',
    ok: '确定',
    clear: '清除',
    startPlaceholder: '起始日期',
    endPlaceholder: '结束日期',
    hour: '时',
    minute: '分',
    second: '秒',
  },
  Dialog: {
    close: '关闭',
    ok: '确定',
    cancel: '取消',
  },
  Message: {
    closeAriaLabel: '关闭',
  },
  Pagination: {
    goTo: '前往',
    page: '页',
    total: '第{current}页，共{total}页',
    labelPrev: '上一页，当前第{current}页',
    labelNext: '下一页，当前第{current}页',
    inputAriaLabel: '请输入跳转到第几页',
    selectAriaLabel: '请选择每页显示几条',
    pageSize: '条/页',
  },
  Input: {
    clear: '清除',
  },
  Select: {
    selectPlaceholder: '请选择',
    autoCompletePlaceholder: '请输入',
    notFoundContent: '无选项',
    maxTagPlaceholder: '已选择 {selected}/{total} 项',
  },
  Table: {
    empty: '没有数据',
    ok: '确定',
    reset: '重置',
    asc: '升序',
    desc: '降序',
    expanded: '已展开',
    folded: '已折叠',
    filter: '筛选',
    selectAll: '全选',
  },
  TimePicker: {
    placeholder: '请选择时间',
    startPlaceholder: '开始时间',
    endPlaceholder: '结束时间',
    clear: '清除',
    hour: '时',
    minute: '分',
    second: '秒',
  },
  Transfer: {
    items: '项',
    item: '项',
    moveAll: '移动全部',
    searchPlaceholder: '请输入',
    moveToLeft: '撤销选中元素',
    moveToRight: '提交选中元素',
  },
  Upload: {
    card: {
      cancel: '取消',
      addPhoto: '上传图片',
      download: '下载',
      delete: '删除',
    },
    drag: {
      text: '点击或者拖动文件到虚线框内上传',
      hint: '支持 docx, xls, PDF, rar, zip, PNG, JPG 等类型的文件',
    },
    upload: {
      delete: '删除',
    },
  },
  Search: {
    buttonText: '搜索',
  },
  Tag: {
    delete: '删除',
  },
  Rating: {
    description: '评分选项',
  },
};
